<div class="header">
    <div class="logo-container" [attr.data-testid]="testIdPrefix ? testIdPrefix + '-home-button' : null" (click)="goToHome()">
        <img src="assets/icons/Avenir-Energy-Logo-side-white.svg">
    </div>
    @if(isLoggedIn) {
    <div class="right-options">
        <div class="l-group">
            <avenir-header-accounting-period [testIdPrefix]="testIdPrefix"></avenir-header-accounting-period>
        </div>
        <div class="l-group">
            <avenir-header-reminder [testIdPrefix]="testIdPrefix"></avenir-header-reminder>
        </div>
        <div class="l-group">
            <div class="user-menu">
                <avenir-header-user-menu [clientId]="clientId" [testIdPrefix]="testIdPrefix"></avenir-header-user-menu>
            </div>
        </div>
    </div>
    }
</div>
